import { render } from "./Simulation.vue?vue&type=template&id=fe322620&scoped=true"
import script from "./Simulation.vue?vue&type=script&lang=js"
export * from "./Simulation.vue?vue&type=script&lang=js"

import "./Simulation.vue?vue&type=style&index=0&id=fe322620&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\sonic\\renault\\new_resources\\renault_configurator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe322620"]])

export default __exports__